<!--子课题审核-->
<template>
    <div class="parent-container">
        <div class="content-container">
            <div class="topic-sign-title">子课题审核</div>
            <div class="topic-sign-name">（{{topicInfo.parentTopicName}}）</div>
            <div class="topic-info-container">
                <div class="topic-info-left">
                    <div class="item-title-container">
                        <div :class="activeTab===1?'item-title title-active':'item-title'" @click="handleTabsClick(1)">基本信息</div>
                        <div :class="activeTab===2?'item-title title-active':'item-title'" @click="handleTabsClick(2)">子课题规划</div>
                        <div :class="activeTab===3?'item-title title-active':'item-title'" @click="handleTabsClick(3)">附件说明</div>
                    </div>
                    <el-form ref="topicForm" :model="topicInfo" :label-width="100">
                        <div class="topic-info" v-if="activeTab===1">
                            <el-row>
                                <el-col :span="14" >
                                    <el-form-item label="教师姓名" prop="leaderNames">
                                        <el-input disabled v-model="topicInfo.sonLeaderNames" placeholder="请输入教师姓名"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="所属学校" prop="orgName">
                                        <el-input disabled v-model="topicInfo.orgName" placeholder="请输入所属学校"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="任教学段" prop="periodKey">
                                        <el-select disabled style="width: 100%;" v-model="topicInfo.periodKey"
                                                   placeholder="请选择任教学段">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="任教学科" prop="subjectKey">
                                        <el-select disabled style="width: 100%;" v-model="topicInfo.subjectKey"
                                                   placeholder="请选择任教学科">
                                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="最高学历" prop="qualificationKey">
                                        <el-select disabled style="width: 100%;" v-model="topicInfo.qualificationKey"
                                                   placeholder="请选择最高学历">
                                            <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="14">
                                    <el-form-item label="技术职称" prop="rankLevel">
                                        <el-select disabled style="width: 100%;" v-model="topicInfo.rankLevel"
                                                   placeholder="请选择技术职称">
                                            <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                       :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="topic-info" v-if="activeTab===2">
                            <el-row>
                                <el-col :span="16" >
                                    <el-form-item label="子课题名称" prop="topicName">
                                        <el-input disabled v-model="topicInfo.topicName" placeholder="请输入子课题名称"  />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="课题报名" prop="applyFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm"
                                                            style="width: 100%;" v-model="topicInfo.applyBeginTime" type="datetime" placeholder="开始时间"
                                                            value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker"
                                                            style="width: 100%;" v-model="topicInfo.applyEndTime"
                                                            type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="开题阶段" prop="ktFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm"
                                                            style="width: 100%;" v-model="topicInfo.ktBeginTime" type="datetime" placeholder="开始时间"
                                                            value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker"
                                                            style="width: 100%;" v-model="topicInfo.ktEndTime"
                                                            type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="中期检查" prop="formTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm"
                                                            style="width: 100%;" v-model="topicInfo.beginTime" type="datetime" placeholder="开始时间"
                                                            value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker"
                                                            style="width: 100%;" v-model="topicInfo.endTime"
                                                            type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="结题验收" prop="jtFormTime">
                                        <el-col :span="11" class="date_picker">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm"
                                                            style="width: 100%;" v-model="topicInfo.jtBeginTime" type="datetime" placeholder="开始时间"
                                                            value-format="x" />
                                        </el-col>
                                        <el-col :span="2" class="text-center">
                                            <span class="text-gray-500">至</span>
                                        </el-col>
                                        <el-col :span="11">
                                            <el-date-picker disabled format="YYYY-MM-DD HH:mm" class="date_picker"
                                                            style="width: 100%;" v-model="topicInfo.jtEndTime"
                                                            type="datetime" placeholder="结束时间" value-format="x" />
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="课题介绍" prop="recommend">
                                        <el-input disabled type="textarea" maxlength="1000" v-model="topicInfo.recommend" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="研究目的" prop="studyAim">
                                        <el-input disabled type="textarea" maxlength="1000" v-model="topicInfo.studyAim" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="研究方法" prop="studyMethod">
                                        <el-input disabled type="textarea" maxlength="1000" v-model="topicInfo.studyMethod" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="其他说明" prop="remarks">
                                        <el-input disabled type="textarea" maxlength="1000" v-model="topicInfo.remarks" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="topic-info" v-if="activeTab===3">
                            <!--附件内容 -->
                            <div class="info-column-container">
                                最高学历证书
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in topicInfo.xlFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                    </div>
                                </div>
                            </div>

                            <!--附件内容 -->
                            <div class="info-column-container">
                                职业证书
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in topicInfo.zcFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                    </div>
                                </div>
                            </div>

                            <!--附件内容 -->
                            <div class="info-column-container" v-if="topicInfo.clFileList&&topicInfo.clFileList.length>0">
                                参与课题证明材料
                            </div>
                            <div class="file-list">
                                <div class="file-item" v-for="item in topicInfo.clFileList" :key="item">
                                    <div class="file-title">{{item.fileName}}</div>
                                    <div class="file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
                <div class="topic-info-right">
                    <div class="topic-info-right-item" v-if="userId===topicInfo.checkUser">
                        <div class="check-user-info">审核:{{topicInfo.checkUserName}}</div>
                        <div class="check-sel" v-if="topicInfo.isCheck===2">
                            <div class="btn-tg"   @click="handleCheckChange(3)"><span v-if="checkForm.isCheck===3">√</span>通过</div>
                            <div class="btn-jj"   @click="handleCheckChange(4)"><span v-if="checkForm.isCheck===4">√</span>驳回</div>
                        </div>
                        <div class="check-sel" v-if="topicInfo.isCheck===3||topicInfo.isCheck===4">
                            <div class="btn-tg-auto" v-if="topicInfo.isCheck===3" >已通过</div>
                            <div class="btn-jj-auto" v-if="topicInfo.isCheck===4" >已驳回</div>
                        </div>
                        <div class="reason-title-container">
                            不通过原因
                        </div>
                        <div class="reason-container">
                            <el-input :disabled="topicInfo.isCheck!==2" v-model="checkForm.reason" type="textarea" rows="6" />
                        </div>
                        <div class="apply-btn-container" >
                            <div class="apply-btn-back" @click="backTopicManager">返回</div>
                            <div v-if="topicInfo.isCheck===2" class="apply-btn" @click="submitCheckInfo">确认</div>
                        </div>
                    </div>
                    <div class="topic-info-right-item" v-if="userId!==topicInfo.checkUser">
                        <div class="check-user-info">审核人:{{topicInfo.checkUserName}}</div>
                        <div class="check-sel">
                            <div class="btn-tg" @click="handleCheckChange(3)"><span v-if="checkForm.isCheck===3">√</span>通过</div>
                            <div class="btn-jj" @click="handleCheckChange(4)"><span v-if="checkForm.isCheck===4">√</span>不通过</div>
                        </div>
                        <div class="reason-title-container">
                            不通过原因
                        </div>
                        <div class="reason-container">
                            <el-input disabled v-model="checkForm.reason" type="textarea" rows="6" />
                        </div>
                        <div class="apply-btn-container" >
                            <div class="apply-btn-back" @click="backTopicManager">返回</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { leadDetail ,leadCheck} from "@/api/admin/lead"
import {timestampToTime} from "@/utils/date";
import {queryDict} from "@/api/admin/public";
import {downloadFile} from "@/api/adminservice/public";
export default {
    name: "topicManager",
    components: {},
    props:{
        subTopicId:{
            type: String,
            default:null,
        },
    },
    watch:{
        subTopicId(newValue,oldValue){
            this.topicId = newValue;
            this.getTopicInfo()
        },
    },
    data() {
        return {
            listMode:'list',
            managerMode:'manager',
            subTopicMode:'subtopic',
            serviceUrl,
            timestampToTime,
            activeTab:1,
            topicId:'',
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            topicInfo:{
                leaderNames:'',
            },
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            checkForm:{
                topicId:'',
                isCheck:"",
                reason:"",
            }
        };
    },
    created() {},
    mounted() {
        this.topicId = this.subTopicId;
        this.getTopicInfo()
    },
    unmounted() {},
    computed: {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
                this.subjectList = [];
                this.periodList.forEach(j => {
                    if (this.topicInfo.periodKey === j.dictKey) {
                        this.subjectList = j.childrenList;
                    }
                })
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        handleTabsClick(item){
            this.activeTab = item;
        },
        getTopicInfo() {
            leadDetail({ topicId: this.topicId }).then(res => {
                  if (res.data.code === 1) {
                      this.topicInfo = res.data.data;
                      this.checkForm.isCheck = this.topicInfo.isCheck;
                      if (this.checkForm.isCheck === 4){
                          this.checkForm.reason = this.topicInfo.reason;
                      }
                      this.getQueryDict()
                  }else {
                      this.$message.error("请求出错")
                  }

            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {

            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,fileType,fileUrl){
            const list = [];
            if (fileType &&(fileType.toLowerCase()==='png'||fileType.toLowerCase()==='jpg'||fileType.toLowerCase()==='jpeg')){
                list.push(fileUrl);
            }else {
                for (let i = 1; i <=page ; i++) {
                    list.push(baseUrl+'/' + i+'.png');
                }
            }

            return list;
        },
        handleCheckChange(selItem){
            this.checkForm.isCheck = selItem;
        },
        submitCheckInfo(){
            if (!this.checkForm.isCheck){
                this.$message.error("请选择是否通过")
                return;
            }
            if (this.checkForm.isCheck === 4&& !this.checkForm.reason) {
                this.$message.error("驳回请输入原因")
                return;
            }
            this.checkForm.topicId = this.topicId
            leadCheck(this.checkForm).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功")
                    this.backTopicManager();
                }else{
                    this.$message.error("请求出错")
                }
            })

        },

        backTopicManager(){
            this.$emit('change-active-mode', this.listMode,"3");
        }

    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #3b62f8;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    text-align: center;
}
.topic-info-container{
    width: 100%;
    height: calc(100% - 80px);
    border-top: 2px solid #3b62f8;
    display: flex;
}
.topic-info-left{
    width: calc(100% - 262px);
    height: 100%;
    border-right: 2px solid #3b62f8;
}
.topic-info-right{
    width: 260px;
    height: 100%;
}
.topic-info-right-item{
    width: 100%;
    height: 100%;
}
.item-title-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.item-title{
    width: auto;
    height: 30px;
    margin-right: 10px;
    line-height: 30px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
}
.title-active{
    color: #3b62f8!important;
    border-bottom: 3px solid #3b62f8!important;
}
.topic-info{
    width: 100%;
    height: calc(100% - 40px);
    padding-top: 10px;
}
/deep/ .el-form-item{
    margin-bottom: 10px!important;
}
/deep/ .el-form-item__label{
    color:#000!important;
    font-weight:bold;
    font-size:14px
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    color:#000!important;
    font-weight:bold;
    font-size:14px;
    line-height: 25px;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #3b62f8!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    color: #3b62f8;
}
.file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
.check-user-info{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
}
.check-sel{
    width: 100%;
    height: 40px;
    margin: auto;
    display: flex;
}
.btn-tg{
    height: 24px;
    width: 70px;
    background-color: #81b337;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    margin-right: 10px;
    border-radius: 5px;
    margin-left: 60px;
    cursor: pointer;
}
.btn-tg-auto{
    height: 24px;
    width: 70px;
    background-color: #81b337;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
    margin: auto;
}
.btn-jj{
    height: 24px;
    width: 70px;
    background-color: #e87b17;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
}
.btn-jj-auto{
    height: 24px;
    width: 70px;
    background-color: #e87b17;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
    margin: auto;
}
.reason-title-container{
    display: flex;
    width: 100%;
    height: 25px;
    color:#000!important;
    font-weight:bold;
    font-size:14px;
    line-height: 25px;
    text-indent: 10px;
}
.reason-container{
    width: 100%;
    height: auto;
    padding-left: 10px;
    padding-top: 10px;
    box-sizing: border-box;

}
.apply-btn-container{
    width: 100%;
    height: 40px;
    padding-top: 30px;
    display: flex;
}
.apply-btn{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #3b62f8;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
}
.apply-btn-back{
    width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background-color: #FFFFFF;
    color: #909399;
    border-radius: 5px;
    margin: auto;
    cursor: pointer;
    border: 1px solid #909399;
}
</style>